import * as React from "react";
import { PackageCardsProps } from "./typings";
import { PackageCard } from "./PackageCard";
import { FlexClickTracker } from "components/utility/analytics/FlexClickTracker/FlexClickTracker";
import { UitkPrimaryButton } from "uitk-react-button";
import { ItemKeyHelper } from "components/utility/ItemKeyHelper";
import { useLocalization } from "@shared-ui/localization-context";
import { PackageCardImageLeftMobile } from "./PackageCardImageLeftMobile";
import { PackageCardImageLeft } from "./PackageCardImageLeft";
import { PackageCardMobile } from "components/flexComponents/Packages/PackageCardMobile";

const ButtonTracked = FlexClickTracker(UitkPrimaryButton);
const keyHelper = new ItemKeyHelper("PackageCards");

const scrollToWizardAndFocusOnDate = (): void => {
  const bundledPackageSelector = "#wizard-package-pwa-1";
  const allInclusiveSelector = "#All-inclusive-vacations";
  const allInclusiveWizard = document.querySelector(allInclusiveSelector);
  const activeWizardSelector = allInclusiveWizard?.classList?.contains("active")
    ? allInclusiveSelector
    : bundledPackageSelector;
  const activeWizard = document.querySelector(activeWizardSelector);
  activeWizard?.scrollIntoView({ block: "start", behavior: "smooth" });
  //Focus on the departure date field
  const activeStartDateInput = document.querySelector(`${activeWizardSelector} #d1-btn`) as HTMLElement;
  activeStartDateInput.focus({ preventScroll: true });
};

export const PackageCards = ({
  context,
  packages,
  isMobile,
  isFullWidth,
  viewType,
  showChooseYourDates,
}: PackageCardsProps) => {
  const { formatText } = useLocalization();
  const languageAndCountryCodeArray = splitLocaleIntoLanguageAndCountryCode(context.locale);
  viewType = viewType ? viewType : "default";
  const componentMap = {
    "image-left-expando-mobile": PackageCardImageLeftMobile,
    "image-left-expando": PackageCardImageLeft,
    default: PackageCard,
    "default-mobile": PackageCardMobile,
  };

  const PackageCardComponent = componentMap[`${viewType}${isMobile ? "-mobile" : ""}`] ?? PackageCardMobile;

  return (
    <>
      {packages?.map((packageItem, index: number) => (
        <PackageCardComponent
          packageItem={packageItem}
          key={keyHelper.next()}
          index={index}
          language={languageAndCountryCodeArray}
          isMobile={isMobile}
        />
      ))}

      {showChooseYourDates && (
        <div className="uitk-type-center">
          <ButtonTracked
            text={formatText("wizard.sticky.cta.label")}
            onClick={scrollToWizardAndFocusOnDate}
            className="all-t-margin-three all-b-margin-two"
            moduleName="packages"
            rfrr="ChooseYourDatesCTA"
            isFullWidth={isFullWidth}
            data-testid="choose-your-dates"
          />
        </div>
      )}
    </>
  );
};

export const splitLocaleIntoLanguageAndCountryCode = (locale?: string): string[] | undefined => locale?.split(/[_-]/);
